import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import CheckBoxOutlineBlankRoundedIcon from '@mui/icons-material/CheckBoxOutlineBlankRounded';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import Button from '@mui/material/Button';
export const CheckboxButton = ({ label, ariaLabel, isChecked, onClick, uncheckedMaterialColor, checkedMaterialColor, showBoxWhenUnchecked = false }) => {
    function getStartIcon() {
        if (isChecked) {
            return _jsx(CheckCircleRoundedIcon, {});
        }
        else if (showBoxWhenUnchecked) {
            return _jsx(CheckBoxOutlineBlankRoundedIcon, {});
        }
    }
    return (_jsx(Button, { "aria-label": ariaLabel, onClick: onClick, startIcon: getStartIcon(), variant: 'contained', color: isChecked ? checkedMaterialColor : uncheckedMaterialColor, children: label }));
};
